import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export type SocialApp =
  | 'instagram'
  | 'facebook'
  | 'messenger'
  | 'twitter'
  | 'x'
  | 'linkedin'
  | 'snapchat'
  | 'tiktok'
  | 'wechat'
  | 'whatsapp'
  | 'telegram'
  | 'unknown'

export function detectSocialApp(ua: string = navigator.userAgent, ref: string = document.referrer): SocialApp {
  const u = ua.toLowerCase()
  const r = ref.toLowerCase()

  if (u.includes('instagram')) return 'instagram'
  if (u.includes('fban') || u.includes('fbav') || u.includes('facebook')) return 'facebook'
  if (u.includes('messenger')) return 'messenger'
  if (u.includes('micromessenger')) return 'wechat'
  if (u.includes('line/')) return 'wechat'
  if (u.includes('twitter')) return 'twitter'
  if (u.includes(' x/')) return 'x'
  if (u.includes('linkedin')) return 'linkedin'
  if (u.includes('snapchat')) return 'snapchat'
  if (u.includes('tiktok')) return 'tiktok'
  if (u.includes('whatsapp')) return 'whatsapp'
  if (u.includes('telegram')) return 'telegram'

  if (r.includes('instagram.com')) return 'instagram'
  if (r.includes('facebook.com')) return 'facebook'
  if (r.includes('twitter.com')) return 'twitter'
  if (r.includes('t.co')) return 'twitter'
  if (r.includes('linkedin.com')) return 'linkedin'
  if (r.includes('snapchat.com')) return 'snapchat'
  if (r.includes('tiktok.com')) return 'tiktok'
  if (r.includes('whatsapp.com')) return 'whatsapp'
  if (r.includes('telegram.org') || r.includes('t.me')) return 'telegram'
  if (r.includes('weixin') || r.includes('wechat')) return 'wechat'

  return 'unknown'
}
